import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TableSortLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const IngredientTable = ({
  ingredients,
  suppliers,
  onEdit,
  onDelete,
  sortConfig,
  setSortConfig,
}) => {
  const getSupplierName = (supplierIdOrObj) => {
    if (typeof supplierIdOrObj === "object") return supplierIdOrObj.name;
    return (
      suppliers.find((s) => s._id === supplierIdOrObj)?.name || supplierIdOrObj
    );
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedIngredients = [...ingredients].sort((a, b) => {
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    if (sortConfig.key === "supplier") {
      aValue = getSupplierName(a.supplier) || "";
      bValue = getSupplierName(b.supplier) || "";
    }

    if (typeof aValue === "string" && typeof bValue === "string") {
      return sortConfig.direction === "asc"
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    } else if (typeof aValue === "number" && typeof bValue === "number") {
      return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
    } else {
      return 0;
    }
  });

  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Table>
        <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
          <TableRow>
            {[
              { label: "Name", key: "name" },
              { label: "Category", key: "category" },
              { label: "Unit", key: "unit" },
              { label: "Unit Amount", key: "unitAmount" },
              { label: "Cost / Unit", key: "costPerUnit" },
              { label: "Supplier", key: "supplier" },
              { label: "Store Path", key: "storePathIndex" },
            ].map((col) => (
              <TableCell key={col.key} sx={{ fontWeight: "bold" }}>
                <TableSortLabel
                  active={sortConfig.key === col.key}
                  direction={
                    sortConfig.key === col.key ? sortConfig.direction : "asc"
                  }
                  onClick={() => handleSort(col.key)}>
                  {col.label}
                </TableSortLabel>
              </TableCell>
            ))}
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedIngredients.map((ing) => (
            <TableRow key={ing._id}>
              <TableCell>{ing.name}</TableCell>
              <TableCell>{ing.category}</TableCell>
              <TableCell>{ing.unit}</TableCell>
              <TableCell>{ing.unitAmount}</TableCell>
              <TableCell>${ing.costPerUnit.toFixed(2)}</TableCell>
              <TableCell>{getSupplierName(ing.supplier)}</TableCell>
              <TableCell>{ing.storePathIndex ?? "—"}</TableCell>
              <TableCell align="right">
                <IconButton onClick={() => onEdit(ing)}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => onDelete(ing._id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default IngredientTable;
